import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FaCheck, FaSync, FaTimesCircle } from 'react-icons/fa';

export type workflowInboxActionsProps = {
    disabledRefresh?: boolean;
    disabledApprove?: boolean;
    disabledReject?: boolean;
    onRefresh?: () => void;
    onApprove?: () => void;
    onReject?: () => void;
};

export const WorkflowInboxActions = (props: workflowInboxActionsProps) => {
    const {
        disabledRefresh,
        disabledApprove,
        disabledReject,
        onRefresh,
        onApprove,
        onReject
    } = props;

    return (
        <Row>
            <Col
                style={{
                    textAlign: 'left',
                    paddingTop: '10px'
                }}
            >
                <div className="container">
                    <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={onRefresh}
                        disabled={disabledRefresh}
                    >
                        <FaSync />
                        &nbsp;Refresh
                    </Button>
                </div>
            </Col>
            <Col
                style={{
                    textAlign: 'right',
                    paddingTop: '10px'
                }}
            >
                <div className="container">
                    <Button
                        variant="outline-success"
                        size="sm"
                        onClick={onApprove}
                        disabled={disabledApprove}
                    >
                        <FaCheck />
                        &nbsp;Approve
                    </Button>
                    <Button
                        variant="outline-danger"
                        size="sm"
                        className="mx-1"
                        onClick={onReject}
                        disabled={disabledReject}
                    >
                        <FaTimesCircle />
                        &nbsp;Reject
                    </Button>
                </div>
            </Col>
        </Row>
    );
};
